import React, { useState, useEffect } from "react";
import { skills } from "./data"; // Import skills data from data.js
import SkillCategory from "./SkillCategory"; // Ensure correct path

const Skills = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // No need for API call, as data is static in data.js
    setLoading(false);  // Set loading to false immediately
  }, []);

  if (loading) {
    return <div>Loading skills...</div>;
  }

  return (
    <section id="skills" className="skills">
      <div className="container">
        <div className="section-title">
          <h2>Skills</h2>
        </div>
        <div className="skills-container">
          {skills.map((category) => (
            <SkillCategory
              key={category.category}  // Use category name as key
              category={category.category}
              skills={category.items}  // Pass skills array
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
